var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDouglasIconsPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF00FF;}\n\t.st1{fill:none;stroke:#FF00FF;stroke-width:0.025;stroke-miterlimit:10;}\n\t.st2{fill:#00FF00;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:square;}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{clip-path:url(#SVGID_6_);}\n\t.st7{clip-path:url(#SVGID_8_);}\n\t.st8{clip-path:url(#SVGID_10_);enable-background:new    ;}\n\t.st9{clip-path:url(#SVGID_12_);}\n\t.st10{clip-path:url(#SVGID_14_);}\n\t.st11{clip-path:url(#SVGID_16_);}\n\t.st12{clip-path:url(#SVGID_18_);}\n\t.st13{clip-path:url(#SVGID_20_);}\n\t.st14{clip-path:url(#SVGID_22_);}\n\t.st15{clip-path:url(#SVGID_24_);}\n\t.st16{clip-path:url(#SVGID_26_);}\n\t.st17{clip-path:url(#SVGID_28_);}\n\t.st18{clip-path:url(#SVGID_30_);}\n\t.st19{clip-path:url(#SVGID_32_);}\n\t.st20{clip-path:url(#SVGID_34_);enable-background:new    ;}\n\t.st21{clip-path:url(#SVGID_36_);}\n\t.st22{clip-path:url(#SVGID_38_);}\n\t.st23{clip-path:url(#SVGID_40_);}\n\t.st24{clip-path:url(#SVGID_42_);}\n\t.st25{clip-path:url(#SVGID_44_);}\n\t.st26{clip-path:url(#SVGID_46_);}\n\t.st27{clip-path:url(#SVGID_48_);}\n\t.st28{fill:none;}\n\t.st29{fill:#1A1A18;}\n\t.st30{fill:#FFFFFF;}\n\t.st31{fill:#1D1D1B;}\n\t.st32{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GRID_x21_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Punkte_Sammeln"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Kostenloser_Versand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_2_"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lieferung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_3_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_10_"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Merkzettel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_8_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_9_"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Warenkorb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_11_"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beautycard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_6_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_7_"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Magazin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_6_"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Special"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_5_"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Gratis_Probe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_4_"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Einladung"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_3_"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Geschenk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_9_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_12_"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Bezahlen"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Umtausch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_1_"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rabatt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_13_"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Drucker"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Kalender"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Social_Media_1_"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Lupe"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "X"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Digital_Invoice"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Geschenkkarte"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "M\\xFClleimer"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Blitz"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Briefumschlag"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Gru\\xDFkarte"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "track_your_order"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "lieferung_in_filiale"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Standort"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Kontakt"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4_x2F_7"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Anmelden_x2F_Abmelden"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "uhr"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Info"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "_x21_"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "_x3F_"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Social_Media"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Parkm\\xF6glichkeit"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Gratis_beigabe"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "mehr_Service"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Tablet"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Zoom"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Bearbeiten"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Benutzer_suchen"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Online_Konto_anlegen"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Kundeninfo"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Tages_Make-Up"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Abend_Make-Up"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Termin_speichern"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Beauty_Mirror"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Gl\\xFChbirne"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Sonder\\xF6ffnungszeiten"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Erinnerngsservice"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Color_Expert"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Open"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "\\xF6ffentliche_Verkehrsmittel"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Scanner"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Einstellungen"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Video"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Online_Produktreservierung"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "surprise_Sample"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "45,22 23,22 23,0 22,0 22,22 0,22 0,23 22,23 22,45 23,45 23,23 45,23  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouglasIconsPlus);
export default __webpack_public_path__ + "static/media/Douglas_Icons_Plus.34e9d68f.svg";
export { ForwardRef as ReactComponent };